import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import { getUser } from "api/authApiCall";
import { useNavigate } from 'react-router-dom';
// reactstrap components
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  Media,
  Navbar,
  NavItem,
  Nav,
  Container,
} from "reactstrap";
import { getUserLogo } from "api/authApiCall";
import { useTranslation } from '../../i18n/context';


function AdminNavbar({ theme, sidenavOpen, toggleSidenav }) {
  const { t } = useTranslation();
  const { locale, changeLanguage } = useTranslation();
  const navigate = useNavigate();
  const user = getUser();
  const logoUrl = getUserLogo();
  // const brand = getUserColor();
  // console.log("Logo URL:", logoUrl);

  // function that on mobile devices makes the search open
  const openSearch = () => {
    document.body.classList.add("g-navbar-search-showing");
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-showing");
      document.body.classList.add("g-navbar-search-show");
    }, 150);
    setTimeout(function () {
      document.body.classList.add("g-navbar-search-shown");
    }, 300);
  };
  // function that on mobile devices makes the search close
  const closeSearch = () => {
    document.body.classList.remove("g-navbar-search-shown");
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-show");
      document.body.classList.add("g-navbar-search-hiding");
    }, 150);
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-hiding");
      document.body.classList.add("g-navbar-search-hidden");
    }, 300);
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-hidden");
    }, 500);
  };

  return (
    <>
      <Navbar
        className={classnames(
          "navbar-top navbar-expand border-bottom",
          { "navbar-dark bg-info": theme === "dark" },
          { "navbar-light bg-secondary": theme === "light" }
        )}
      >
        <Container fluid>
          <Collapse navbar isOpen={true}>
            <Form
              className={classnames(
                "navbar-search form-inline mr-sm-3",
                { "navbar-search-light": theme === "dark" },
                { "navbar-search-dark": theme === "light" }
              )}
            >
              <button
                aria-label="Close"
                className="close"
                type="button"
                onClick={closeSearch}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </Form>

            <Nav className="align-items-center ml-md-auto" navbar>
              <NavItem className="d-xl-none">
                <div
                  className={classnames(
                    "pr-3 sidenav-toggler",
                    { active: sidenavOpen },
                    { "sidenav-toggler-dark": theme === "dark" }
                  )}
                  onClick={toggleSidenav}
                >
                  <div className="sidenav-toggler-inner">
                    <i className="sidenav-toggler-line" />
                    <i className="sidenav-toggler-line" />
                    <i className="sidenav-toggler-line" />
                  </div>
                </div>
              </NavItem>
            </Nav>
            <Nav className="align-items-center ml-auto ml-md-0" navbar>
              <select
                value={locale}
                onChange={(e) => changeLanguage(e.target.value)}
              >
                <option value="en"> 🇬🇧</option>
                <option value="fr">🇫🇷</option>
                <option value="pt">🇵🇹</option>
              </select>
              <UncontrolledDropdown nav>
                <DropdownToggle className="nav-link pr-0" color="" tag="a">
                  <Media className="align-items-center">
                    <span className="avatar avatar-sm rounded-circle">
                      <img
                        src={logoUrl}
                        alt="User Logo"
                        onError={() => console.error("Error loading image")}
                        onLoad={() => console.log("Image loaded successfully")}
                      />

                    </span>
                    <Media className="ml-2 d-none d-lg-block">

                      {user && <span className="mb-0 text-sm font-weight-bold">{user.name}!
                      </span>}
                    </Media>
                  </Media>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem className="noti-title" header tag="div">
                    <h6 className="text-overflow m-0">{t('common.welcome')}</h6>
                  </DropdownItem>
                  <DropdownItem
                    // onClick={() => navigate('/profile')}
                    // onClick={(e) => e.preventDefault()}
                    href="/admin/users"
                  >
                    <i className="ni ni-single-02" />
                    <span>{t('dashboard.profile')}</span>
                  </DropdownItem>
                  {/* <DropdownItem
                    href="#"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="ni ni-settings-gear-65" />
                    <span>Settings</span>
                  </DropdownItem> */}
                  <DropdownItem divider />
                  <DropdownItem
                    onClick={() => navigate('/logout')}
                  // onClick={(e) => e.preventDefault()}
                  >
                    <i className="ni ni-user-run" />
                    <span>{t('dashboard.logout')}</span>
                  </DropdownItem>

                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

AdminNavbar.defaultProps = {
  toggleSidenav: () => { },
  sidenavOpen: false,
  theme: "dark",
};
AdminNavbar.propTypes = {
  toggleSidenav: PropTypes.func,
  sidenavOpen: PropTypes.bool,
  theme: PropTypes.oneOf(["dark", "light"]),
};

export default AdminNavbar;
